/**
 * useIsMobile — responsive breakpoint detection hook.
 * Returns true when viewport width < 768px.
 *
 * Uses window.matchMedia (best practice) instead of resize event:
 * - Only fires when the breakpoint threshold is actually crossed
 * - Does NOT fire on iOS keyboard open/close (height-only change)
 * - No debouncing needed — browser handles natively
 * - More performant than resize event listener
 *
 * Pattern validated against community best practices (2025-2026).
 */

import { useState, useEffect } from 'react'

const MOBILE_QUERY = '(max-width: 767px)'

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MOBILE_QUERY).matches : false
  )

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY)
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [])

  return isMobile
}
